var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$validateText(_vm.text))?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.text,
        trigger: _vm.eventListeners,
    }),expression:"{\n        content: text,\n        trigger: eventListeners,\n    }"}],staticClass:"d-inline-block"},[_vm._t("default",function(){return [_c('i',{staticClass:"bi bi-info-circle-fill text-info",class:_vm.iconClass})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }